import React from 'react';
import { compose, withState, withHandlers } from 'recompose';
import { Flex, Div, Button } from './hocs/withStyles';
import skyscannerSvg from '../svgs/skyscanner.svg';
import { version } from '../config';
import { saveFeedback } from '../utils/firebaseUtils';

const About = compose(
  withState('from', 'setFrom', ''),
  withState('msg', 'setMsg', ''),
  withHandlers({
    clearForm: ({ setFrom, setMsg }) => () => {
      setFrom('');
      setMsg('');
    }
  }),
  withHandlers({
    submitMsg: ({ from, msg, clearForm, uid }) => e => {
      e.preventDefault();
      if (!msg) return;
      saveFeedback({
        from,
        msg,
        version,
        uid
      });
      clearForm();
    }
  })
)(props => {
  const { msg, from, setMsg, setFrom, submitMsg } = props;
  return (
    <Flex
      p={[2, 3]}
      direction="column"
      maxWidth="600px"
      css={{
        '@media (orientation: portrait)': {
          padding: '0.8em'
        }
      }}>
      <Div p={[2, 0]}>
        <h1>About Us</h1>
        <Div p={[2, 0, 0, 0]}>
          Kairos keeps an eye on the weather for you!<br />We suggest spontaneous trips
          with lots of sunshine.
          <br />
          <strong>Seize the Moment!</strong>
        </Div>
      </Div>
      <Div m={[3, 0]}>
        <h3>Get in Touch!</h3>
        <Div css={{ fontSize: '0.9em' }}>
          Give us your feedback, request a feature, or report a bug.<br />We would love to
          hear from you!
        </Div>
        <form onSubmit={submitMsg}>
          <Flex direction="column">
            <Div m={[2, 0]}>
              Your email:<br />
              <input
                type="text"
                placeholder="type email here..."
                value={from}
                onChange={e => {
                  setFrom(e.target.value);
                }}
                style={{
                  width: '90%',
                  height: '34px',
                  padding: '0 0.3em'
                }}
              />
            </Div>
            <Div>
              Your message:<br />
              <textarea
                placeholder="type message here"
                value={msg}
                onChange={e => {
                  setMsg(e.target.value);
                }}
                style={{
                  height: '200px',
                  width: '90%',
                  padding: '0.3em'
                }}
              />
            </Div>
            <Div m={[1, 0]}>
              <Button p={[2, 3]}>Submit</Button>
            </Div>
          </Flex>
        </form>
      </Div>
      <Div m={[2, 0]}>
        <h3>Weather</h3>
        <div>From OpenWeatherMap</div>
      </Div>
      <Div m={[2, 0, 0, 0]}>
        <h3>Flight Info</h3>
        <img
          src={skyscannerSvg}
          alt="powered by Skyscanner"
          width="290px"
          style={{
            position: 'relative',
            right: '15px',
            bottom: '50px'
          }}
        />
      </Div>
      <Div m={[1, 0, 0, 0]}>
        App version {version}
      </Div>
    </Flex>
  );
});

export default About;



// WEBPACK FOOTER //
// ./src/components/About.js